import axios from 'axios';
import request from '../../../../../logic/utils/request';
import { REPORT_TYPES } from '../../../../../logic/utils/reportRequest';

// Полный /server/api/zone/ отдаёт у каждой зоны config экранов терминала (мегабайты),
// а здесь нужны только id и название — берём их лёгким запросом.
// Запрос идёт напрямую через axios: общий request() при HTTP-ошибке разлогинивает,
// а ошибка здесь не критична — откатываемся на полный список.
export default async function fetchZoneList() {
  try {
    const token = window.localStorage.getItem('token');
    // Токен в теле, а не в URL — чтобы не оседал в логах прокси и сервера
    const { data } = await axios.post('/api/sql-reports/report', {
      token,
      data: { reportType: REPORT_TYPES.ZONE_LIST },
    });
    if (data.error || !Array.isArray(data.data)) throw new Error('zone_list недоступен');
    return data.data.map(([id, name]) => ({ id: Number(id), name }));
  } catch (e) {
    const res = await request('/server/api/zone/', 'get');
    return res.data.data;
  }
}
